<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar c-avatar-lg">
          <img v-if="!$store.state.data.avatar" class="c-avatar-img"  :src="'https://api.hamkaran.cloud/avatar/'+$store.state.data.email" />
          <img v-if="$store.state.data.avatar != null" class="c-avatar-img"  :src="JSON.parse($store.state.data.avatar).urlResized" />
        </div>
      </CHeaderNavLink>
    </template>

    <CDropdownItem to="/profile">
      <CIcon name="cil-user" /> پروفایل {{$store.state.data.company}}
    </CDropdownItem>
    <CDropdownItem v-if="0" to="/accounting">
      <CIcon class="top_menu" name="cil-dollar" /> 
      حسابداری
      <CBadge color="secondary" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem  :to="($store.state.data.access_level === 1)?'/admin/tickets':'/ticket'">
      <CIcon class="top_menu" name="cil-life-ring" /> پشتیبانی
      <CBadge color="primary" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownDivider />
    <CDropdownItem @click="logout">
      <CIcon class="top_menu" name="cil-lock-locked" /> خروج
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 0,
    };
  },
  methods: {
    logout: function () {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
    margin-left: 7px;
}
</style>